import React, { useEffect } from 'react'
import circle from '../../../images/main/curcle.svg'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import smoothscroll from 'smoothscroll-polyfill'

const CookiePolicy = ({ ourRef }) => {
  smoothscroll.polyfill()
  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <Link to='/' className={styles.left_wrap}>
          <span>&larr;</span>Вернуться назад
        </Link>
        <p>Политика использования cookie</p>
      </div>
      <div className={styles.right}>
        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>Что такое cookie?</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Cookies (файлы cookie) - это небольшой фрагмент данных, отправленный веб-сервером и хранимый на вашем устройстве. Каждый раз при попытке открыть страницу соответствующего сайта браузер пересылает этот фрагмент данных серверу в составе HTTP-запроса.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>Как мы используем файлы cookie?</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Цель использования файлов cookie заключается в том, чтобы сайт запомнил ваши предпочтения (местоположение, язык и т.д.). Это исключает необходимость повторно вводить их при очередном посещении сайта.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Также файлы cookie используются для ведения анонимной статистики о посещаемости сайтов и позволяют нам и нашим партнерам показывать вам релевантную рекламу при посещении нашего сайта и других сторонних сайтов, включая социальные сети.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Большинство современных браузеров позволяет выбрать — принимать обработку файлов cookie или нет, но их отключение влияет на корректность работы с сайтом.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>Как мы обрабатываем файлы cookie?</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Сервер использует файл cookie клиента, чтобы просмотреть связанные сведения из кэша. Это делается для управления сессиями на сайте и персонализации сервисов, в том числе, с использованием метрических программ и систем аналитики, таких как Яндекс.Метрика.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>Какие виды файлов cookie мы используем?</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Сессионные (временные) - существуют только во временной памяти, пока вы находитесь на сайте. Обычно удаляются после того, как вы закрываете страницу браузера. Такой вид файлов cookie необходим, чтобы избежать повторного ввода информации.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Постоянные - позволяют идентифицировать ваше устройство и при вашем возвращении на сайт вспоминают информацию об устройстве и о действиях, совершенных вами ранее. Этот вид файлов cookie удаляется через определённое время или когда вы решите очистить cookie. То есть браузер будет передавать информацию на сервер при каждом вашем посещении сайта, пока данные не будут удалены.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Обязательные - необходимы для корректной работы сайта и сервисных служб, например для входа в систему и обеспечения безопасности вашего аккаунта.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Сторонние - принадлежат другому домену. Обычно они встраиваются на страницы других сайтов, например, в виде рекламного блока. Создатель файла cookie может получать данные о посетителях.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Защищенные - такие файлы cookie передаются через шифрованное https-соединение HttpOnly. Они не видны коду браузера и отправляются только на сервер компании, что позволяет предотвратить их утечку.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>Важно</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Файлы cookie это НЕ вирус, они не заразят ваше устройство;
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Файлы cookie НЕ могут повредить жесткий диск устройства;
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Файлы cookie НЕ получают с вашего устройства ваши личные данные, они позволяют анализировать только вашу активность на сайте;
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Файлы cookie НЕ тормозят работу сайта, наоборот, их отключение приведет к снижению скорости обработки ваших запросов.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy
